module.exports = __webpack_public_path__ + "img/top_desc_bg.732a583c.png";